<template>
    <div id="pay_form">
        <kt-panel>
            <div class="accordion accordion-toggle-arrow" id="userFilter">
                <div class="card" style="overflow:inherit">
                    <div class="card-header bg-transparent" id="headingOne">
                        <div class="card-title collapsed" data-toggle="collapse"
                             data-target="#filterForm"
                             aria-controls="filterForm">
                            {{ $t('label.search') }}
                        </div>
                    </div>
                    <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)" id="open_banking_requests_export_form">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="statusSelectGroup">
                                                <kt-form-label for="status">
                                                    {{ $t('label.status') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="status" class="form-control"
                                                                name="status" v-model="query.status"
                                                >
                                                    <option :value="null" v-text="$t('label.all_statuses')"
                                                    ></option>
                                                    <option :value="1" v-text="$t('label.success')"></option>
                                                    <option :value="2" v-text="$t('label.failed')"></option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="provider">
                                                <kt-form-label for="provider">
                                                    {{ $t('application.provider') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="provider" class="form-control"
                                                                name="provider" v-model="query.provider"
                                                >
                                                    <option :value="null" v-text="$t('label.all_providers')"
                                                    ></option>
                                                    <option v-for="provider in walletOpenBankingRequestProvider"
                                                            :value="provider"
                                                    >
                                                        {{walletOpenBankingRequestProviderStr.get(provider)}}
                                                    </option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="service">
                                                <kt-form-label for="service">
                                                    {{ $t('open_banking.service') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="service" class="form-control"
                                                                name="service" v-model="query.service"
                                                >
                                                    <option :value="null" v-text="$t('label.all_services')"
                                                    ></option>
                                                    <option v-for="service in services"
                                                            v-bind:key="service"
                                                            v-bind:value="service"
                                                            :selected="query.service === service"
                                                    >
                                                        {{$t('application.services.'+service)}}
                                                    </option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="from_date">
                                                    {{ $t('label.from_date') }}
                                                </kt-form-label>
                                                <button id="reset_from_date"
                                                        @click="clearFromDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name="from_date"
                                                    v-model="query.from_date"
                                                    type="datetime"/>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="to_date">
                                                    {{ $t('label.to_date') }}
                                                </kt-form-label>
                                                <button id="reset_to_date"
                                                        @click="clearToDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name="to_date"
                                                    v-model="query.to_date"
                                                    type="datetime"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="9" md="9" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="caller_path">
                                                    {{ $t('label.caller_path') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                    ref="caller_path"
                                                    dir="ltr"
                                                    name="caller_path"
                                                    id="caller_path"
                                                    v-model="query.caller_path"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" class="mt-4">
                                            <input type="submit" class="btn btn-success btn-wide"
                                                   :value="$t('label.filter')">
                                            <button id="open_banking_requests_excel_export" type="button"
                                                    class="btn btn-success btn-wide mx-4" @click="exportToExcel">
                                                {{ $t('label.excel_export') }}
                                            </button>
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </kt-panel>
        <div class="row my-2">
            <div class="col-6">
                <transactionStat
                    :transactionStatistics="success_requests_count"
                    :title="$t('label.success_requests_count')"
                    :needCurrency="false"
                />
            </div>
        </div>
        <kt-datatable ref="datatable" v-bind="datatableProps">
        </kt-datatable>
    </div>
</template>

<script>
import {ApiUrl, walletService, authService} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "../datatable/open-banking-request-columns";
import {services} from '@/constants/openBanking'
import {walletOpenBankingRequestProviderStr, walletOpenBankingRequestProvider} from "@/constants/WalletOpenBankingRequest";

import $ from 'jquery'
import {i18n} from "@/plugins/i18n";
import transactionStat from '@/views/transaction/components/transaction-statistic'
import ActiveToken from "@/views/transaction/components/active-token.vue";
import {KTApp} from '@/plugins/core/app'
import axios from "axios";

export default {
    components: {
        ActiveToken,
        transactionStat,
    },
    data() {
        return {
            query: {
                from_date: null,
                to_date: null,
                bank_id: null,
                user_id: this.prop_user_hashid,
                bank_ref_code: null
            },
            success_requests_count: 0,
            services,
            walletOpenBankingRequestProviderStr,
            walletOpenBankingRequestProvider,
        };
    },
    props: {
        prop_user_hashid: {
            required: false
        },
        fetch_starshop: {
            default: false,
            type: Boolean
        },
        api_base_path: {
            default: ApiUrl.path(''),
            type: String
        }
    },
    methods: {
        loadStats() {
            const fetchStats = this.fetch_starshop
                ? walletService.adminGetStarshopOpenBankingRequestsStats
                : walletService.adminGetCoreOpenBankingRequestsStats;

            fetchStats(this.query).then(res => {
                this.success_requests_count = res.data.data.success_requests_count;
            });
        },
        filterAction(e, query) {
            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }

            this.loadStats();
        },
        clearFromDate() {
            if (this.query.from_date) {
                this.query.from_date = null;
            }
        },
        clearToDate() {
            if (this.query.to_date) {
                this.query.to_date = null;
            }
        },
        exportToExcel(e){

            let form = $('#open_banking_requests_export_form')
            let btn = $('#open_banking_requests_excel_export')

            if(!form.valid()) {
                return
            }


            KTApp.progress(btn)
            axios({
                url: this.api_base_path + 'wallet/common/admin/open-banking-requests-excel-report',
                method: 'GET',
                params: {query: this.query},
                responseType: 'blob',
            })
                .then((response) => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", "WalletOpenBankingRequests.xlsx");
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    KTApp.unprogress(btn)

                })
                .catch(({response}) => {
                    KTApp.unprogress(btn)
                    this.toastr.error(response.data.message)
                })
                .finally(()=>{
                    delete this.query.transaction_type;
                })
        },

    },
    mounted() {
        this.loadStats();
    },
    computed: {
        datatableProps() {
            return {
                id: "wallets_transactions_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.api_base_path + 'wallet/common/admin/open-banking-requests',
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: res => {
                                let result = [];

                                for (let item of res.data.data) {
                                    result.push({...item, check: false});
                                }

                                return result;
                            },
                            params: {
                                query: this.query,
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
                selector: {
                    class: 'kt-checkbox--solid'
                },
            }
        },
    },
}
</script>
